import { Box, TextField, Grid, MenuItem, useMediaQuery, useTheme } from '@mui/material'
import { feeFieldStyles, totalsReadOnlyFieldStyles } from '../style'
import { dynamicGridSizes } from '../style'
import StyledInputAdornment from '../../ui/styled-input-adornment'
import { NewDeal, Totals } from 'types'
import { FC } from 'react'

type NumberOfPaymentsFieldProps = {
  deal?: NewDeal
  totals: Totals
  onChange: (field: keyof NewDeal, value: any) => void
}
const NumberOfPaymentsField: FC<NumberOfPaymentsFieldProps> = ({ deal, totals, onChange }) => {
  const theme = useTheme()
  const isTallScreen = useMediaQuery('(min-height: 1200px)')
  const gridSizes = dynamicGridSizes(isTallScreen)
  const fieldBgColor = theme.palette.background.paper
  return (
    <Grid item {...gridSizes.numberOfPayments} xs={6} sm={6} md={6} lg={6} xl={6}>
      <Box width={'100%'} pb={2}>
        <TextField
          label="Payments"
          name="numberOfPayments"
          disabled={!deal?.isDraft}
          InputProps={{
            startAdornment: <StyledInputAdornment text={'#'} />,
            readOnly: totals && totals.total && totals.total < 2501 ? true : false,
            sx: { borderColor: 'red' },
          }}
          select
          value={deal.numberOfPayments}
          onChange={e => onChange('numberOfPayments', String(e.target.value))}
          sx={
            totals && totals.total && totals.total < 2501
              ? {
                  ...totalsReadOnlyFieldStyles(fieldBgColor),
                  height: '65px',
                }
              : {
                  ...feeFieldStyles(fieldBgColor),
                  height: '65px',
                }
          }
        >
          {[
            { label: '1', value: '1' },
            { label: '2', value: '2' },
            { label: '3', value: '3' },
            { label: '4', value: '4' },
            { label: '5', value: '5' },
            { label: '6', value: '6' },
          ].map(option => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      </Box>
    </Grid>
  )
}
export default NumberOfPaymentsField
